<!-- 人员列表 -->
<template>
    <div class='page_content'>
        <setUserOrgAction ref="setUserOrgAction"></setUserOrgAction>
        <operCreditAction ref="operCreditAction"></operCreditAction>
        <operCreditActionLin ref="operCreditActionLin"></operCreditActionLin>
        <settingUserJurisdiction ref="settingUserJurisdiction"></settingUserJurisdiction>
        <!-- 穿梭框 -->
        <el-dialog :title="dotitle" :visible.sync="dialogtrasfertable" width="80%">
            <transfertable ref="transfertable" :unitExistVOList='unitExistVOList' :unitNoExistVOList="unitNoExistVOList"
                :tableLabel="tableLabel" :configleft="configleft" :configright="configright" @changePage="getList()"
                @edit="editUser" @selection="addUser">
            </transfertable>
        </el-dialog>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="业务员名称">
                        <label slot="label" :style="$common.labelStyle('业务员名称')" v-html="'业务员名称'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.opmName" placeholder="业务员名称"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
                border style="width: 100%" highlight-current-row>
                <el-table-column header-align='center' label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="opmName" label="业务员">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="creditMoney" label="授信金额">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="creditPeriod" label="信贷期">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="tempMoney" label="临时授信金额">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="tempPeriod" label="临时信贷期">
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="validity" label="有效期">
                    <template slot-scope="scope">
                        <div v-if="scope.row.validity">
                            {{ $common.getLocalTime(scope.row.validity) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column header-align='center' align="center" prop="createTime" label="创建时间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.createTime">
                            {{ $common.getLocalTime(scope.row.createTime) }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog title="设置APP权限" :visible.sync="appDia" width="700px">
            <div>
                <el-tree :data="appList" ref="tree" show-checkbox node-key="id" @check="handleCheckChange"
                    default-expand-all :default-checked-keys="selList" :props="defaultProps">
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="appDia = false">取 消</el-button>
                <el-button type="primary" @click="confirmApp">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 不可见字段 -->
        <invisibleField ref="invisibleField"></invisibleField>
        <modulelist ref="modulelist"></modulelist>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import invisibleField from "@/components/invisibleField.vue";
import modulelist from "@/components/modulelist.vue";
import operCreditAction from "@/components/operCreditAction.vue";
import operCreditActionLin from "@/components/operCreditActionLin.vue";
import settingUserJurisdiction from "@/components/settingUserJurisdiction.vue";
import setUserOrgAction from "@/components/setUserOrgAction.vue";
import transfertable from '@/components/transfertable.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        invisibleField,
        modulelist,
        operCreditAction,
        operCreditActionLin,
        settingUserJurisdiction,
        setUserOrgAction,
        transfertable
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            selectedDataIndex: 0,
            buttonList: [],
            getRequestData: {
                opmName: "",
                page: 1,
                rows: 30,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },

            departmentList: [],
            appDia: false,
            appList: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            selList: [],
            appOpmId: "",
            dialogtrasfertable: false,
            unitNoExistVOList: [],
            unitExistVOList: [],
            tableLabel1: [
                {
                    prop: "unitName",
                    label: "单位名称",
                    width: 100,
                },
                {
                    prop: "legalperson",
                    label: "法定代表人",
                    width: 100,
                },
                {
                    prop: "regaddres",
                    label: "注册地址",
                    width: 100,
                },
                // {
                //   prop: "socialcode",
                //   label: "统一社会信用代码",
                //   width: 100,
                // },
            ],
            tableLabel: [],
            bgmtableLabel: [
                {
                    prop: "bgmName",
                    label: "通用名称",
                    width: 100,
                },
                // {
                //   prop: "bgmId",
                //   label: "商品ID",
                //   width: 100,
                // },
            ],
            opmtableLabel: [
                {
                    prop: "opmName",
                    label: "业务员",
                    width: 100,
                },
                {
                    prop: "userName",
                    label: "货主业务员名称",
                    width: 100,
                },
            ],
            cotableLabel: [
                {
                    prop: "stName",
                    label: "库房名称",
                    width: 100,
                },
            ],
            transfertype: 0,
            unitType: 0,
            configleft: {
                page: 1,
                rows: 30,
                total: 0,
                loading: false,
                name: "",
            },
            configright: {
                page: 1,
                rows: 30,
                total: 0,
                loading: false,
                name: "",
            },
            dotitle: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleCheckChange(currentObj, treeStatus) {
            console.log(currentObj, treeStatus)
            console.log(this.$refs.tree.getCheckedNodes());
        },
        // 绑定商品
        chuansuo(unitType) {
            this.dialogtrasfertable = true;
            this.getList();
            this.unitType = unitType;
        },
        // 绑定
        async getList() {
            console.log(this.configleft, this.configright);
            // 供货商客户
            if (this.transfertype == 8) {
                this.tableLabel = this.tableLabel1;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: 0,
                    page: this.configright.page,
                    rows: 30,
                    unitName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    unitName: this.configleft.name,
                };
                let datae = await this.$http.userUnitqueryUserNoExistUnit(asleft);
                let responseData = await this.$http.userUnitqueryUserExistUnit(asright);
                if (responseData.status == 200) {
                    this.unitExistVOList = responseData.result.list;
                    this.configright.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (datae.status == 200) {
                    this.unitNoExistVOList = datae.result.list;
                    this.configleft.total = datae.result.total;
                } else {
                    this.$message({
                        message: datae.message,
                        type: "error",
                    });
                }
                // 商品
            } else if (this.transfertype == 9) {
                this.tableLabel = this.tableLabel1;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: 1,
                    page: this.configright.page,
                    rows: 30,
                    unitName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    unitName: this.configleft.name,
                };
                let datae = await this.$http.userUnitqueryUserNoExistUnit(asleft);
                let responseData = await this.$http.userUnitqueryUserExistUnit(asright);
                if (responseData.status == 200) {
                    this.unitExistVOList = responseData.result.list;
                    this.configright.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (datae.status == 200) {
                    this.unitNoExistVOList = datae.result.list;
                    this.configleft.total = datae.result.total;
                } else {
                    this.$message({
                        message: datae.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 10) {
                this.tableLabel = this.bgmtableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    bgmName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    bgmName: this.configleft.name,
                };
                let responseData = await this.$http.userGoodsqueryUserNoExistGoods(
                    asleft
                );
                let datae = await this.$http.userGoodsqueryUserExistGoods(asright);
                if (datae.status == 200) {
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 11) {
                this.tableLabel = this.opmtableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    opmName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    opmName: this.configleft.name,
                };
                let responseData = await this.$http.couserqueryNoUser(asleft);
                let datae = await this.$http.couserqueryUser(asright);
                if (datae.status == 200) {
                    console.log(datae);
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            } else if (this.transfertype == 12) {
                this.tableLabel = this.cotableLabel;
                let asright = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configright.page,
                    rows: 30,
                    stName: this.configright.name,
                };
                let asleft = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    unitType: this.unitType,
                    page: this.configleft.page,
                    rows: 30,
                    stName: this.configleft.name,
                };
                let responseData = await this.$http.userStqueryUserNoExistSt(asleft);
                let datae = await this.$http.userStqueryUserExistSt(asright);
                if (datae.status == 200) {
                    this.unitExistVOList = datae.result.list;
                    this.configright.total = datae.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                if (responseData.status == 200) {
                    this.unitNoExistVOList = responseData.result.list;
                    this.configleft.total = responseData.result.total;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 选取
        async addUser(unitIdList) {
            console.log(unitIdList, "----");
            // 供货商客户

            if (this.transfertype == 8) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                    unitType: 0,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 9) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                    unitType: 1,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 10) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.bgmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    goodsList: aslist,
                };
                let responseData = await this.$http.userGoodssetUserGoodsData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 11) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.opmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.couseradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 12) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.stId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 0,
                    stIds: aslist,
                };
                let responseData = await this.$http.userStadd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            }
        },
        // 取消
        async editUser(unitIdList) {
            if (this.transfertype == 8) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                    unitType: 0,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 9) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.unitId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                    unitType: 1,
                };
                let responseData = await this.$http.userUnitsetUserUnitData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 10) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.bgmId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    goodsList: aslist,
                };
                let responseData = await this.$http.userGoodssetUserGoodsData(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 11) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.opmId);
                });
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    unitIdList: aslist,
                };
                let responseData = await this.$http.couseradd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            } else if (this.transfertype == 12) {
                let aslist = [];
                unitIdList.forEach((item) => {
                    aslist.push(item.stId);
                });
                //   商品
                let as = {
                    opmId: this.returnData.list[this.selectedDataIndex].opmId,
                    operateType: 1,
                    stIds: aslist,
                };
                let responseData = await this.$http.userStadd(as);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message);
                    this.getList();
                } else {
                    this.$message.error(responseData.message);
                }
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData)
            this.dotitle = actionData.jurName;
            this.transfertype = actionData.actionType;
            switch (actionData.actionType) {
                case 0:
                    this.$refs["operCreditAction"].openBox(
                        actionData.actionType,
                        this.departmentList,
                        ""
                    );
                    break;
                case 1:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["operCreditAction"].openBox(
                        actionData.actionType,
                        this.departmentList,
                        dataInfo
                    );
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.$refs["operCreditActionLin"].openBox(
                        actionData.actionType,
                        this.returnData.list[this.selectedDataIndex],
                        ""
                    );
                    break;
            }
        },
        // 重置密码
        resetPass() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将重置密码，是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.opmId],
                    };
                    let responseData = await this.$http.resetPassword(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                })
        },
        // 设置不可见字段
        openInvi() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$refs.invisibleField.openDia(dataInfo.opmId)
        },
        async settingAppJurisdiction() {
            let responseData = await this.$http.getAllAppJurisdiction();
            if (responseData.status == 200) {
                this.handleJurisdiction(responseData.result);
                this.appList = this.handleJurisdiction(responseData.result);
                this.appDia = true;
                this.getOneAppJurisdiction();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getOneAppJurisdiction() {
            this.selList = [];
            this.appOpmId = this.returnData.list[this.selectedDataIndex].opmId;
            let sendDataInfo = {
                ids: [this.appOpmId],
            };
            let responseData = await this.$http.getOneAppJurisdiction(sendDataInfo);
            if (responseData.status == 200) {
                var arr = this.handleJurisdiction(responseData.result);
                var arrIds = []
                arr.forEach(item1 => {
                    this.appList.forEach(item => {
                        if (item.children.length != item1.children.length && item.mpJurId == item1.mpJurId) {
                            arrIds.push(item.mpJurId)
                        }
                    })
                })
                responseData.result.forEach((item, i) => {
                    this.selList.push(Number(item.mpJurId));
                });
                arrIds.forEach(item => {
                    this.selList.forEach((val, key) => {
                        if (val == item) {
                            this.selList.splice(key, 1)
                        }
                    })
                })
                console.log(this.selList);
                this.selList = JSON.parse(JSON.stringify(this.selList));
                this.$refs.tree.setChecked(this.selList, true);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async confirmApp() {
            var keyList = this.$refs.tree.getCheckedKeys();
            var nodeList = this.$refs.tree.getCheckedNodes();
            this.appList.forEach(item => {
                nodeList.forEach(item1 => {
                    if (item.mpJurId == item1.mpJurParentid) {
                        keyList.push(item.mpJurId)
                    }
                })
            })
            var arr = Array.from(new Set(keyList))
            let sendDataInfo = {
                mpJurId: arr,
                opmId: this.appOpmId,
            };
            let responseData = await this.$http.saveAppJurisdiction(sendDataInfo);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "保存成功",
                });
                this.appDia = false;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                value["selectedStatus"] = false;
                if (value["mpJurParentid"] == id) {
                    value["id"] = value["mpJurId"];
                    value["value"] = value["mpJurId"];
                    value["label"] = value["mpJurName"];
                    var list = this.handleJurisdiction(data, value["mpJurId"], lev + 1);
                    value["children"] = this.handleJurisdiction(
                        data,
                        value["mpJurId"],
                        lev + 1
                    );
                    son.push(value);
                }
            });
            return son;
        },
        openUserJurisdiction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$refs["settingUserJurisdiction"].openBox(dataInfo);
        },
        // 设置人员组织
        async settingOrder() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$refs["setUserOrgAction"].openBox(dataInfo);
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 修改状态
        async setDataAction() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            var sendData = {
                ids: [dataInfo.opmId],
            };
            let responseData = await this.$http.setUserStatus(sendData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功!",
                });
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.ocrId],
                    };
                    let responseData = await this.$http.opercreditDelete(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.opercreditQuery(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取全部部门
        async getAllDepartmentList() {
            var list = [];
            let requestData = await this.$http.getAllDepartmentList();
            if (requestData.status == 200) {
                list = this.departmentListMenu(requestData.result, 0, 0);
            }
            this.departmentList = list;
        },

        // 整理部门树
        departmentListMenu(data, id = 0, lev = 0, selectId = "") {
            var son = [];
            data.forEach((value, keys) => {
                if (selectId == value["depId"]) {
                    value["disabled"] = true;
                }
                if (value["pdepId"] == id) {
                    value["value"] = value["depId"];
                    value["label"] = value["depName"];
                    value["level"] = lev;
                    var list = this.departmentListMenu(data, value["depId"], lev + 1);
                    if (list.length >= 1) {
                        value["children"] = list;
                    }
                    son.push(value);
                }
            });
            return son;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
        this.getButtonList();
        this.getAllDepartmentList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>